var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('sr-breadcrumbs',{attrs:{"items":[{text: 'Home',to:{name: 'Home'} }, {text: 'Reports', to:{name: 'Report'}, disabled: true}]}}),_c('v-row',[_c('v-col',[_c('sr-report')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }